const mfaAndResetDeliveryOptionsTemplate = `
<!---------- BEGIN Loader ---------->
<div id="statementsDocs-spinner" class="loaderBackground just-element" ng-if="!mfa.dataLoaded">
    <div class="loader"></div>
</div>
<!---------- END Loader ---------->

<!---------- BEGIN Error alert ---------->
<div id="form-alert" role="alert">
    <alert-message type="alert" ng-if="formOnError">
        {{"generalError"| translate }}
    </alert-message>
</div>
<!---------- END Error alert ---------->

<!---------- BEGIN form ---------->
<div ng-if="mfa.dataLoaded" data-ng-class="getFormGroupClass()">
    <label for="deliveryOption">Where should we send your code?</label>

    <select
        name="deliveryOption"
        class="form-control"
        id="deliveryOption"
        data-ng-init="activationCodeModel.deliveryOption='none'"
        data-ng-model="activationCodeModel.deliveryOption"
        data-ng-disabled="!!emptyDeliveryOptionsMessage"
        ng-change="codeDeliveryChange(activationCodeModel.deliveryOption)"
        aria-invalid="{{formOnError}}"
        aria-describedby="deliveryOptionRules deliveryOptionError">

        <option value="none">Choose delivery method</option>
        <option ng-repeat="option in mfa.deliverySet"
                ng-disabled= "!!internationalPhoneMessage & option.deliveryPhoneType === 'IntlPhoneNumber'"
                value="{{option.deliveryType}}"
                aria-label="{{option.deliveryMask}}">
            {{option.deliveryMask}}
        </option>

    </select>

    <!---------- BEGIN form errors ---------->
    <div id="deliveryOptionError" aria-live="assertive" aria-atomic="true" ng-if="formOnError" sr-order="2">
        <alert-message>
            <!-- ERROR: Empty options error. -->
            <p ng-if="emptyDeliveryOptionsMessage"
                class="error-message-content">
                {{emptyDeliveryOptionsMessage}}
            </p>
            <!-- ERROR: International support unavailable. -->
            <p ng-if="internationalPhoneMessage" class="error-message-content">{{internationalPhoneMessage}}</p>
            <!-- ERROR: Server errors. -->
            <p ng-if="mfa.errorMessage"
                class="error-message-content" 
                translate="MFA_{{mfa.errorMessage}}"
                translate-default="We are unable to send verification codes at this time. Please try again. Contact a Participant Services Representative if the problem continues.">
            </p>
        </alert-message>
    </div>
    <!---------- END form errors ---------->
</div>

<!-- LINK ON LOGIN - Already have a code -->
<a ng-show="$state.current.name === 'loginHelpDeliveryOptions' && emptyDeliveryOptionsMessage == null"
   ui-sref="verifyCodeForLoginHelp"
   class="secondary-cta"
   ng-click="verifyCodeLoginHelp()">
   {{ "alreadyHasCode" | translate }}
</a>

<!-- LINK ON ACTIVATION - Already have a code link -->
<a ng-show="$state.current.name === 'activationCodeDeliveryOptions' && emptyDeliveryOptionsMessage == null"
   ui-sref="verifyCode"
   class="secondary-cta"
   ng-click="verifyCode()">
   {{ "alreadyHasCode" | translate }}
</a>

<!-- SUBMIT BUTTON -->
<div class="form-group clearfix" ng-if="mfa.dataLoaded">            
    <button type="submit" class="btn btn-primary btn-lg btn-block margin-top-default outline-btn" ng-disabled="emptyDeliveryOptionsMessage !== null && showSpinner==true" id="deliveryOptionsContinue">
        <span data-ng-hide="showSpinner==true" id="deliveryOptionsContinueLabel">
            Send me a Code
        </span>
                                
        <span data-ng-show="showSpinner==true" id="deliveryOptionsContinueSpinner">
            <i class="fa fa-circle-o-notch fa-spin"></i>
            Processing ...
        </span>
    </button>
</div>

<!---------- END form ---------->

<!---------- BEGIN Screen Reader Support ---------->
<span class="sr-only" id="deliveryOptionRules">
    {{"pleaseEnterActivationDeliveryDescription" | translate }}
</span>
<!---------- END Screen Reader Support ---------->

<!---------- BEGIN Disclaimers ---------->
<div ng-if="mfa.dataLoaded" aria-live="assertive">
    <p ng-if="activationCodeModel.alert === 'show'"
        class="text-notation form-details"
        translate="sendActivationCodeAlert"></p>
</div>
<!---------- END Disclaimers ---------->
`;
export default mfaAndResetDeliveryOptionsTemplate;
